import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import _ from "vendor/lodash";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";
import spartaEventsUtility from "global/sparta-events-utility";







const EVENTS = {
  ELEMENT_UNSTICK: 'UNSTICK.spartaStickUtility',
  ELEMENT_STICK: 'STICK.spartaStickUtility',
  ELEMENT_FADE_IN: 'FADE_IN.spartaStickUtility',
  SPARTA_GLOBAL_READY: 'SPARTA_GLOBAL_READY.spartaBootstrapUtility',
};

const stickyClass = 'spa-sticky';







function _getStickPoints(html, body, $el) {
  const $globalFooter = $('#globalFooterModule, #universalFooterModule');
  const pageHeight = _getPageHeight(body, html);
  const parent = $el.attr('data-parent');
  const $stickStartEl = $($el.attr('data-sticky-start'));
  const $stickEndEl = $($el.attr('data-sticky-end'));
  const stickyOverFooter = $el.attr('data-sticky-footer');
  const $startingPointEl = ($stickStartEl.length) ? $stickStartEl : $el;
  const stickPoint = Math.floor($startingPointEl.offset().top);
  let unStickPoint = ($stickEndEl.length) ? Math.round($stickEndEl.offset().top) - $el.height() : pageHeight;
  let limits = pageHeight;

  if (parent && parent !== 'body') {

    const $parent = $el.closest(parent);
    limits = Math.round($parent.height() - (stickPoint - $parent.offset().top));
    unStickPoint = isNaN(stickPoint + limits) ? pageHeight : stickPoint + limits;
  }

  if (((!parent || parent === 'body') && !$stickEndEl.length) && !stickyOverFooter && $globalFooter[0]) {

    unStickPoint = Math.round($globalFooter.offset().top) - $el.height();
  }

  return {
    stickPoint,
    unStickPoint
  };
}

function _getPageHeight(body, html) {
  return Math.max(body.scrollHeight,
    body.offsetHeight,
    html.clientHeight,
    html.scrollHeight,
    html.offsetHeight);
}




class SpartaStickyEl {










  constructor($win, body, html, el, level, stickPoint, unStickPoint, gap = 150) {
    this.$el = $(el);
    this.$placeholder = null;
    this.$win = $win;
    this.body = body;
    this.el = el;
    this.gap = gap;
    this.html = html;
    this.level = level;
    this.stickPoint = stickPoint;
    this.unStickPoint = unStickPoint;
    this.fullWidth = el.getAttribute('data-sticky-full-width');
    this.fade = el.getAttribute('data-sticky-fade');
    this.levelOffset = this.getLevelOffset();

    this.addPlaceholder();
    this.initStyle();
  }

  get EVENTS() {
    return EVENTS;
  }




  getLevelOffset() {
    let levelOffset = 0;
    let x = this.level;

    while (x--) {
      const levelEl = document.querySelector(`.${stickyClass}[data-sticky-level="${x}"].active`);
      if (levelEl && levelEl !== this.el) {
        levelOffset += levelEl.offsetHeight;
      }
    }
    return levelOffset;
  }

  initStyle() {
    (this.$el.attr('data-sticky-fade')) && this.$el.addClass('hide');
  }





  addPlaceholder() {
    const fade = this.$el.attr('data-sticky-fade');

    const height = this.$el.attr('data-placeholder') !== "false" ? this.$el.outerHeight() : 0;
    const width = this.$el.width();

    this.$placeholder = (fade) ? $(`<div class="sticky-placeholder-fade"></div>`) : $(`<div class="sticky-placeholder"></div>`);
    if (!fade) {
      this.$placeholder.css({
        width,
        height
      });
    }
    this.$el.after(this.$placeholder);
  }




  updatePlaceholder() {
    const height = this.el.offsetHeight;
    const width = this.el.offsetWidth;

    (width) && this.$placeholder.css({
      width
    });
    (height) && this.$placeholder.css({
      height
    });
  }





  removePlaceholder() {
    this.$placeholder.remove();
  }





  handleResize(dist) {
    this.$el.removeClass('active').attr('style', '');
    const {
      stickPoint,
      unStickPoint
    } = _getStickPoints(this.html, this.body, this.$el);

    this.stickPoint = stickPoint;
    this.unStickPoint = unStickPoint;
    this.updateSticky(dist);
    this.updatePlaceholder();
  }




  updateSticky(dist) {
    const goOffScreen = this.unStickPoint - this.gap;
    const isCurrentlyStuck = this.$el.hasClass('active');
    const levelOffset = this.getLevelOffset();
    const stickPoint = this.stickPoint - levelOffset;
    const unStickPoint = this.unStickPoint - levelOffset;


    if (stickPoint <= dist && unStickPoint > dist) {

      if (!isCurrentlyStuck) {
        spartaEventsUtility.pub(EVENTS.ELEMENT_STICK, {
          $el: this.$el
        });
      }


      if (!isCurrentlyStuck || this.getLevelOffset() !== this.levelOffset) {
        this.levelOffset = this.getLevelOffset();


        let width = (this.fullWidth) ? `100%` : `${this.$el.width()}px`;
        let left = (this.fullWidth) ? `0` : `${this.el.getBoundingClientRect().left}px`;


        if (this.fade) {
          this.$el.removeClass('hide');
          width = (this.fullWidth) ? `100%` : `${this.$placeholder[0].offsetWidth}px`;
          left = (this.fullWidth) ? `0` : `${this.$placeholder[0].getBoundingClientRect().left}px`;
        }



        const height = `${this.el.offsetHeight}px`;
        const top = `${levelOffset}px`;

        this.$el.css({
            left,
            top,
            width
          })
          .addClass('active')
          .removeClass('fade-out');


        this.$el.on('animationend.sticky', e => {
          if (this.el.isEqualNode(e.target) && e.originalEvent.animationName === 'fadeIn') {
            spartaEventsUtility.pub(EVENTS.ELEMENT_FADE_IN, [$(e.target)]);
            this.$el.off('animationend.sticky');
          }
        });

        this.fade && this.$el.addClass('fade-in');
        return;
      }


      if (this.$el.hasClass('active')) {
        return;
      }
    }


    if (dist > goOffScreen) {

      if (isCurrentlyStuck) {
        spartaEventsUtility.pub(EVENTS.ELEMENT_UNSTICK, {
          $el: this.$el
        });
        this.$el.addClass('fade-out')
          .removeClass('active')
          .removeAttr('style');
        if (this.fade) {
          this.$el.addClass('hide');
        }
      }
    }


    if (dist < this.stickPoint) {

      if (isCurrentlyStuck) {
        spartaEventsUtility.pub(EVENTS.ELEMENT_UNSTICK, {
          $el: this.$el
        });
        this.$el.removeClass('active')
          .removeClass('fade-out fade-in')
          .removeAttr('style');
        if (this.fade) {
          this.$el.addClass('hide');
        }
      }
    }
  }
}









const stickyApi = (function initializeStickyModules(doc, win, els) {
  const sticky = {



    init() {
      this.$win = $(win);
      this.body = doc.querySelector('body');
      this.html = doc.documentElement;
      this.isMobile = this.html.classList.contains('touch');

      this.stickyEls = [].slice.call(els);
      this.stickyElsInstances = [];

      this.setupObservers();
      this.setupEvents();
      this.createStickyInstances();
      this.pageHeight = _getPageHeight(this.body, this.html)
    },





    getCurrentDist() {
      return (this.html && this.html.scrollTop) || document.body.scrollTop;
    },









    setupEvents() {
      const boundResize = this.resizeHandler.bind(this);


      spartaEventsUtility.sub('UNFREEZE_SCROLL.spartaUILayersUtility', _.throttle(() => {
        _.delay(boundResize, 50)
      }, 500));


      spartaEventsUtility.sub(EVENTS.ELEMENT_UNSTICK, boundResize);

      this.$win.on('spartaWindowScroll', () => {
        (this.pageHeight !== _getPageHeight(this.body, this.html)) && boundResize();
        this.pageHeight = _getPageHeight(this.body, this.html);
      });

      if (this.isMobile) {
        this.$win.on('orientationchange.sticky', _.throttle(() => {
          _.delay(boundResize, 50)
        }, 500));
        this.$win.on('spartaWindowScroll', this.scrollHandler.bind(this));
      } else {
        this.$win.on('scroll.sticky touchmove.sticky', this.scrollHandler.bind(this));
        this.$win.on('resize.sticky', _.throttle(boundResize, 1000));
      }
    },




    removeEvents() {
      this.$win.off('.sticky');
    },





    setupObservers() {
      if (window.MutationObserver) {

        this.stickyEls.forEach(el => {
          const observer = new MutationObserver(this.handleObserve.bind(this));
          observer.observe(el.parentElement, {
            childList: true
          });
        });
      }
    },








    handleObserve(record) {
      record.forEach(r => {
        let removedNodes = null;
        if (r.removedNodes.length) {
          removedNodes = r.removedNodes;

          [].slice.call(removedNodes).forEach(node => {
            if (node.classList.contains(stickyClass)) {
              this.removeStickyInstances([node]);
            }
          });
        }
      });

      if (!this.stickyElsInstances.length) {
        this.removeEvents();
      }
    },




    scrollHandler() {
      const currentPageHeight = _getPageHeight(this.body, this.html);
      const dist = this.getCurrentDist();

      this.updateStickyInstances();
    },





    resizeHandler() {
      const dist = this.getCurrentDist();
      this.stickyElsInstances.forEach(instance => {
        instance.handleResize(dist);
      });
    },




    createStickyInstances(elsToCreate = this.stickyEls) {
      elsToCreate.forEach(el => {
        el = (el.jquery) ? el.get(0) : el;
        const $el = (el.jquery) ? el : $(el);
        const {
          stickPoint,
          unStickPoint
        } = _getStickPoints(this.html, this.body, $el);
        let level = $el.attr('data-sticky-level');
        let parent = $el.attr('data-sticky-parent');

        if (!level) {
          level = 1;
          $el.attr('data-sticky-level', level);
        }

        if (!parent) {
          parent = 'body';
          $el.attr('data-sticky-parent', parent);
        }


        $el.addClass(stickyClass);


        this.stickyElsInstances.push(new SpartaStickyEl(this.$win, this.body, this.html, el, level, stickPoint, unStickPoint));


        if (this.getCurrentDist() > 0) {
          this.updateStickyInstances();
        }
      }, this);
    },





    removeStickyInstances(elsToRemove = this.stickyEls) {
      let elems = elsToRemove;

      if (!Array.isArray(elems)) {
        elems = [].slice.call(elems);
      }

      elems.forEach((el) => {
        let idx = null;

        if (el.jquery) {
          el = el.get(0);
        }



        this.stickyElsInstances.some((instance, i) => {

          if (instance.el.isEqualNode(el)) {
            idx = i;
            return true;
          }
        });
        if (idx !== null) {
          this.stickyElsInstances[idx].removePlaceholder();
          this.stickyElsInstances.splice(idx, 1);
          el.classList.remove(stickyClass, 'active');
          el.removeAttribute('style');
          spartaEventsUtility.pub(EVENTS.ELEMENT_UNSTICK, {
            $el: this.$el
          });
        }
      }, this);
    },





    updateStickyInstances(dist = this.getCurrentDist()) {
      this.stickyElsInstances.forEach(instance => {
        instance.updateSticky(dist);
      });
    },
  };


  spartaEventsUtility.sub(EVENTS.SPARTA_GLOBAL_READY, () => {
    if (els.length) {
      sticky.init(els);
    }
  });

  return {
    addStickyEls: sticky.createStickyInstances.bind(sticky),
    removeStickyEls: sticky.removeStickyInstances.bind(sticky),
    updateStickyEls: sticky.updateStickyInstances.bind(sticky),
    EVENTS,
  };
}(document, window, document.querySelectorAll(`.${stickyClass}`)));

export default stickyApi;
